import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InterviewService } from 'src/app/pages/virtual-interview/services/interview.service';

@Component({
  selector: 'app-start-interview',
  templateUrl: './start-interview.component.html',
  styleUrls: ['./start-interview.component.css'],
})
export class StartInterviewComponent {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {}
  vrId: string | null = null;
  ngOnInit() {
    this.vrId = this.route.snapshot.params['id'];
  }
  startInterview() {
    if (this.vrId) {
      this.router.navigate(['start-interview-session', this.vrId]);
    }
  }
}
